import { cache } from 'react';

import { api } from '@/lib/api';
import { getClientSessionOrThrow } from '@/lib/client-session-auth';
import { createServerApi } from '@/lib/server-api';

/**
 * Confirm user age (18+) by updating profile
 */
export const confirmAgeReq = async (): Promise<{ success: boolean; error?: string }> => {
  try {
    const { accessToken } = await getClientSessionOrThrow();

    await api.patch(
      '/api/users/profile',
      { isAdult: true },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return { success: true };
  } catch (error) {
    console.error('Error confirming age:', error);
    return { success: false, error: 'Не удалось подтвердить возраст' };
  }
};

/**
 * Check if user has confirmed age from profile data
 */
export const checkAgeConfirmation = (userData: { isAdult?: boolean } | null): boolean => {
  return userData?.isAdult === true;
};

/**
 * Get user's age confirmation status from server
 * Used in server components to check if user has confirmed they are 18+
 */
export const getUserIsAdultReq = cache(async (): Promise<boolean> => {
  try {
    const serverApi = await createServerApi();
    const res = await serverApi.get('/api/users/me');

    if (res.status !== 200) {
      return false;
    }

    // Response structure: { success: true, user: { isAdult: boolean, ... } }
    return res.data?.user?.isAdult === true;
  } catch (error) {
    return false;
  }
});
